document.addEventListener('click', async (event) => {
  // --- Close/dismiss button (added; existing quick-add logic below is unchanged) ---
  const closeButton = event.target.closest('[data-soie-cross-sell-close]');
  if (closeButton) {
    const section = closeButton.closest('.soie-cross-sell');
    if (section) {
      section.setAttribute('hidden', '');
      try {
        sessionStorage.setItem('soieCrossSellDismissed', '1');
      } catch (e) {
        /* ignore storage errors (e.g. private browsing) */
      }
    }
    return;
  }

  const button = event.target.closest('[data-soie-quick-add]');
  if (!button || button.disabled) return;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    // SOIE: stay on the cart page after adding a recommended item. The theme's
    // <cart-items-component> (assets/component-cart-items.js) already knows how to
    // update itself without a full reload: it listens on `document` for the
    // 'cart:update' event (ThemeEvents.cartUpdate) and, when the event detail carries
    // rendered section HTML for its own section id, morphs that HTML into place instead
    // of reloading. We ask /cart/add.js to render every cart-items-component section on
    // the page (there may be a cart drawer AND the cart page section at once) and then
    // dispatch that same event with the returned sections, exactly like the theme's own
    // quantity-selector update flow does. Since main-cart.liquid renders the line items,
    // the cart summary, and this cross-sell grid all inside one <cart-items-component>
    // section, one morph updates all three together -- including re-running the
    // cross-sell snippet's "already_in_cart" check server-side, so the item's own card
    // disappears from the recommendations the moment it's added. The product image and
    // title links are plain <a href> anchors untouched by this script, so clicking the
    // image still navigates to the product page exactly as before.
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = new Set();
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: Array.from(sectionIds).join(','),
        sections_url: window.location.pathname
      })
    });
    if (!response.ok) throw new Error('Unable to add product');
    const result = await response.json();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { sections: result.sections } }
      })
    );
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.querySelector('span:first-child').textContent = 'Try again';
  }
});

// --- Keep the section dismissed for this browsing session even after the cart
// drawer/page re-renders (e.g. after quantity changes), so closing it "sticks". ---
(() => {
  const STORAGE_KEY = 'soieCrossSellDismissed';

  const isDismissed = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const hideDismissedSections = () => {
    if (!isDismissed()) return;
    document.querySelectorAll('.soie-cross-sell:not([hidden])').forEach((section) => {
      section.setAttribute('hidden', '');
    });
  };

  hideDismissedSections();

  if ('MutationObserver' in window) {
    new MutationObserver(hideDismissedSections).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
